// extracted by mini-css-extract-plugin
export default {"root":"style_root__TEV9U","opponent":"style_opponent__K0QdX"};